import type { CampaignOrder } from '@brightlocal/api-client';

/**
 * Whether the campaign has been paid for and so has nothing left to edit.
 *
 * `paid` is the API's name for `is_charged()`, which is also the condition Tools redirects
 * a campaign here on. The two must stay exact complements — refusing anything Tools will
 * hand over bounces the customer between the platforms — so status stays out of this test
 * even though the BE rejects saves for a fulfilment-owned campaign too.
 *
 * @param orders - The campaign's orders, as `GET /citation-builder/{id}` returns them.
 */
export const isEveryOrderPaid = (orders: readonly Pick<CampaignOrder, 'paid'>[]) =>
  orders.length > 0 && orders.every(({ paid }) => paid);
